
import { useEffect, useState } from "react";
import api from "../services/api";

export default function CommissionPage() {
  const [taxi,         setTaxi]         = useState(null);
  const [interRegions, setInterRegions] = useState(null);
  const [savingTaxi,   setSavingTaxi]   = useState(false);
  const [savingIR,     setSavingIR]     = useState(false);
  const [tab,          setTab]          = useState("taxi");

  useEffect(() => {
    api.get("/admin/commission/taxi").then(res => setTaxi(res.data));
    api.get("/admin/commission/inter-regions").then(res => setInterRegions(res.data));
  }, []);

  const saveTaxi = async () => {
    setSavingTaxi(true);
    await api.put("/admin/commission", taxi);
    setSavingTaxi(false);
    alert("Paramètres TAXI sauvegardés ✅");
  };

  const saveIR = async () => {
    setSavingIR(true);
    await api.put("/admin/commission/inter-regions", interRegions);
    setSavingIR(false);
    alert("Paramètres ALLO-DAKAR sauvegardés ✅");
  };

  if (!taxi || !interRegions) return <p style={{ padding: 20 }}>Chargement...</p>;

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ marginBottom: "1.5rem" }}>
        <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>💸 Commissions</h1>
        <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>
          Gestion des taux de commission par type de service
        </p>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        {[
          { key: "taxi",        label: "🚕 TAXI",       color: "#0B3C5D" },
          { key: "inter",       label: "🚌 ALLO-DAKAR", color: "#FFA500" },
        ].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: "10px 20px", borderRadius: 10, border: "none",
            cursor: "pointer", fontSize: 14, fontWeight: 500,
            background: tab === t.key ? t.color : "#f0f0f0",
            color:      tab === t.key ? "#fff"   : "#888",
            transition: "all 0.2s",
          }}>{t.label}</button>
        ))}
      </div>

      {/* ===== TAXI ===== */}
      {tab === "taxi" && (
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, border: "0.5px solid #e5e5e5", maxWidth: 520 }}>
          <p style={{ fontSize: 15, fontWeight: 600, color: "#0B3C5D", marginBottom: 20 }}>
            🚕 Commission TAXI
          </p>

          {_renderForm(taxi, setTaxi, saveTaxi, savingTaxi, "#0B3C5D")}
        </div>
      )}

      {/* ===== ALLO-DAKAR ===== */}
      {tab === "inter" && (
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, border: "0.5px solid #e5e5e5", maxWidth: 520 }}>
          <p style={{ fontSize: 15, fontWeight: 600, color: "#FFA500", marginBottom: 20 }}>
            🚌 Commission ALLO-DAKAR
          </p>

          {_renderForm(interRegions, setInterRegions, saveIR, savingIR, "#FFA500")}
        </div>
      )}
    </div>
  );
}

function _renderForm(settings, setSettings, onSave, saving, color) {
  const taux = Math.round((settings.commission_rate ?? 0) * 100);

  return (
    <div>
      {/* Taux */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
          Taux de commission (%)
        </label>
        <input
          type="number" min="0" max="100" step="1"
          value={taux}
          onChange={e => setSettings({ ...settings, commission_rate: parseFloat(e.target.value) / 100 })}
          style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "0.5px solid #ddd", fontSize: 15, boxSizing: "border-box" }}
        />
      </div>

      {/* Mode gratuit */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={settings.gratuit ?? false}
            onChange={e => setSettings({ ...settings, gratuit: e.target.checked })}
            style={{ width: 18, height: 18 }}
          />
          <span style={{ fontSize: 14, fontWeight: 500, color: "#0B3C5D" }}>
            Période sans commission (lancement)
          </span>
        </label>
      </div>

      {/* Dates période gratuite */}
      {settings.gratuit && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>
              Date début
            </label>
            <input
              type="date"
              value={settings.gratuit_debut?.split("T")[0] ?? ""}
              onChange={e => setSettings({ ...settings, gratuit_debut: e.target.value })}
              style={{ width: "100%", padding: "10px", borderRadius: 8, border: "0.5px solid #ddd", fontSize: 13, boxSizing: "border-box" }}
            />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>
              Date fin
            </label>
            <input
              type="date"
              value={settings.gratuit_fin?.split("T")[0] ?? ""}
              onChange={e => setSettings({ ...settings, gratuit_fin: e.target.value })}
              style={{ width: "100%", padding: "10px", borderRadius: 8, border: "0.5px solid #ddd", fontSize: 13, boxSizing: "border-box" }}
            />
          </div>
        </div>
      )}

      {/* Message */}
      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
          Message aux chauffeurs (optionnel)
        </label>
        <textarea
          value={settings.message ?? ""}
          onChange={e => setSettings({ ...settings, message: e.target.value })}
          placeholder="Ex: Bienvenue ! Commission offerte jusqu'au 31 janvier 🎉"
          rows={3}
          style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "0.5px solid #ddd", fontSize: 13, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }}
        />
      </div>

      {/* Aperçu */}
      <div style={{ background: "#f7f7f7", borderRadius: 8, padding: 14, marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>Aperçu — place à 5 000 CFA</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 13, color: "#888" }}>Commission</span>
          <span style={{ fontSize: 16, fontWeight: 600, color: settings.gratuit ? "#3B6D11" : color }}>
            {settings.gratuit
              ? "0 CFA 🎉"
              : `${Math.round(5000 * (settings.commission_rate ?? 0))} CFA`}
          </span>
        </div>
      </div>

      {/* Bouton */}
      <button onClick={onSave} disabled={saving} style={{
        width: "100%", padding: 12, borderRadius: 8, border: "none",
        background: saving ? "#ccc" : color,
        color: "#fff", fontSize: 14, cursor: saving ? "default" : "pointer", fontWeight: 500,
      }}>
        {saving ? "Sauvegarde..." : "💾 Sauvegarder"}
      </button>
    </div>
  );
}
